import { Quiz } from '../../@types/quiz.interfaces';
import {
    QuizActionType,
    QUIZZES,
    QUIZ,
    CLEAR_QUIZ,
    CLEAR_QUIZZES,
} from './quiz.actions';

interface IState {
    quiz: Quiz | null;
    quizzes: Quiz[] | null;
}

const INITIAL_STATE: IState = {
    quiz: null,
    quizzes: null,
};

export default function quizReducer(
    state: IState = INITIAL_STATE,
    action: QuizActionType
): IState {
    switch (action.type) {
        case QUIZ:
            return {
                ...state,
                quiz: action.payload.quiz,
            };
        case QUIZZES:
            return {
                ...state,
                quizzes: action.payload.quizzes,
            };
        case CLEAR_QUIZ:
            return {
                ...state,
                quiz: null,
            };
        case CLEAR_QUIZZES:
            return {
                ...state,
                quizzes: null,
            };
        default:
            return state;
    }
}
